import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import { PrimaryInfoAlert } from "react-common-ui-library";
import { useIntl } from "react-intl";
import { CONTACT_NUMBER, TRUE } from "../../../Constants/CommonConstants";
import ConfigService from "../../../Services/ConfigService";

const contactNumber = ConfigService(CONTACT_NUMBER);

/**
 * @description Info alert that can be imported in ForgotUsername component.
 * @param {String} contentId id for the content that will be displayed inside the alert.
 * @param {String} title id for the content that will be displayed on alert header.
 * @returns {ReactNode} Render the PrimaryInfoAlert from component library that accepts title and contentId as props.
 */
const ForgotUsernameInfoAlert = ({ title, contentId }) => {
  const intl = useIntl();

  return (
    <PrimaryInfoAlert
      title={title ? intl.formatMessage({ id: title }) : null}
      content={
        <Typography id={contentId}>
          {intl.formatMessage(
            { id: contentId },
            { contactNumber: contactNumber }
          )}
        </Typography>
      }
      hideIcon={TRUE}
    />
  );
};

ForgotUsernameInfoAlert.defaultProps = {
  title: null,
};

ForgotUsernameInfoAlert.propTypes = {
  title: PropTypes.string,
  contentId: PropTypes.string.isRequired,
};

export default ForgotUsernameInfoAlert;
